var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatAlignCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M7.085 5h9.83a.51.51 0 00.514-.504v-.992A.509.509 0 0016.916 3H7.085a.509.509 0 00-.514.503v.993c0 .278.23.504.514.504zM20.82 19H3.18a.673.673 0 00-.679.667v.666c0 .369.304.667.679.667h17.64a.673.673 0 00.679-.667v-.666A.673.673 0 0020.82 19zm0-10.667H3.18A.673.673 0 002.501 9v.667c0 .368.304.666.679.666h17.64a.672.672 0 00.679-.666V9a.673.673 0 00-.679-.667zm-3.905 7.334a.509.509 0 00.513-.504v-.993a.508.508 0 00-.513-.503h-9.83a.509.509 0 00-.514.503v.993c0 .278.23.504.514.504h9.83z"
  }))));
}

export default SvgFormatAlignCenter;